var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningConformIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2922"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2",
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#FF7A00",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M55.3603 46.3156L44.1493 26.8973C42.3182 23.6895 37.6875 23.6895 35.863 26.8973L24.6454 46.3156C22.8143 49.5234 25.0934 53.5085 28.7886 53.5085H51.1776C54.8728 53.5085 57.1914 49.4839 55.3603 46.3156ZM39.9996 49.2007C39.0247 49.2007 38.2145 48.3905 38.2145 47.4156C38.2145 46.4407 39.0247 45.6305 39.9996 45.6305C40.9744 45.6305 41.7846 46.4407 41.7451 47.4617C41.7912 48.3905 40.9349 49.2007 39.9996 49.2007ZM41.6265 37.6604C41.5475 39.0436 41.4619 40.4203 41.3828 41.8035C41.3433 42.2514 41.3433 42.6598 41.3433 43.1012C41.3038 43.8323 40.7307 44.3988 39.9996 44.3988C39.2684 44.3988 38.7019 43.8718 38.6558 43.1407C38.5373 40.9868 38.4121 38.8724 38.2935 36.7184C38.254 36.152 38.2145 35.5789 38.1684 35.0124C38.1684 34.0771 38.6953 33.3064 39.5516 33.0627C40.4079 32.8585 41.2577 33.2669 41.6265 34.0771C41.7517 34.3603 41.7912 34.6436 41.7912 34.9729C41.7517 35.8753 41.666 36.7711 41.6265 37.6604Z",
    fill: "#FF7A00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningConformIcon);
export default __webpack_public_path__ + "static/media/warning-conform-icon.bad21545fa65c47c754da15a57cac81f.svg";
export { ForwardRef as ReactComponent };